// local storage keys
const DISPLAY_CANCELED_SURVEYS_KEY = 'displayCanceledSurveys'

export { DISPLAY_CANCELED_SURVEYS_KEY }
